<template>
  <div class="footer">
    <span>ⓒ MiDAS H&T. All rights reserved</span>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/constant';
  @import '../assets/scss/mixins';

  /* ------------------
  :: Footer Area CSS
  ------------------ */
  .main + .footer {
    background: $color-bg-gray;
  }
  .footer {
    height: 120px;
    background: $color-white;

    @include flexbox;
    @include justify-content(center);
    @include align-items(center);

    & > span {
      font-size: 12px;
      line-height: 2.22;
      color: $color-light-gray;
      opacity: 0.4;
    }
  }

  @media (min-width: 576px) {
    .footer {
      & > span {
        font-size: 18px;
      }
    }
  }
</style>
